import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@shared/shared.module";
import { ManualPayoutProcessDialogComponent } from "./manual-payout-process-dialog.component";
import { MatDividerModule } from "@angular/material/divider";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyDialogModule as MatDialogModule } from "@angular/material/legacy-dialog";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";

import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";

@NgModule({
	declarations: [ManualPayoutProcessDialogComponent],
	exports: [ManualPayoutProcessDialogComponent],
	imports: [
		CommonModule,
		SharedModule,
		FormsModule,
		ReactiveFormsModule,
		MatDividerModule,
		MatDialogModule,
		MatButtonModule,
		MatFormFieldModule,
		MatSelectModule
	]
})
export class ManualPayoutProcessDialogModule {}
